@if (current) {
  <alg-select
    [(ngModel)]="current"
    (change)="languageChanged($event)"
  >
    @for (lang of languages; track $index) {
      <alg-select-option [value]="lang">
        {{ lang.label }}
      </alg-select-option>
    }
  </alg-select>
}

